import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "options", "dropdownStyles"],
  _excluded2 = ["label"];
import { isValidElement, cloneElement } from 'react';
import { DropdownDivider } from '../DropdownDivider';
import { List, ListItem } from '../../List';
import { warnIfFragment } from '../../../utils/warnIfFragment';
import { DropdownMenuOption } from '../internal/DropdownMenuOption';
import { SubDropdownMenu } from '../internal/SubDropdownMenu';
import { jsx as _jsx } from "react/jsx-runtime";
export const renderMenuItem = (option, index) => {
  // case where you just pass in a React element instead of an object (convenience)
  if ( /*#__PURE__*/isValidElement(option)) {
    warnIfFragment(option, 'renderMultiLevelMenu', 'option');
    return /*#__PURE__*/cloneElement(option, {
      key: index
    });
  }
  // case of passing in a nested menu
  else if (option && option.label && option.options) {
    const {
        label,
        options,
        dropdownStyles
      } = option,
      rest = _objectWithoutPropertiesLoose(option, _excluded);
    return /*#__PURE__*/_jsx(SubDropdownMenu, Object.assign({
      buttonText: label,
      dropdownStyles: dropdownStyles
    }, rest, {
      options: options,
      popoverProps: Object.assign({}, rest.popoverProps, {
        marginInlineStart: '-100',
        marginBlockStart: '-200'
      })
    }), index);
  }
  // case of passing in an element with options for the menu
  else if (option && typeof option === 'object' && 'label' in option) {
    const {
        label
      } = option,
      rest = _objectWithoutPropertiesLoose(option, _excluded2);
    return /*#__PURE__*/_jsx(DropdownMenuOption, Object.assign({}, rest, {
      children: label
    }), index);
  }
  // don't return anything if it isn't valid
  return null;
};
export const renderMenu = abstractTree => {
  if (!abstractTree || abstractTree.length === 0) return null;
  return /*#__PURE__*/_jsx(List, {
    role: "menu",
    children: abstractTree.map((option, index) => {
      if (Array.isArray(option)) {
        const items = option.map((item, index2) => /*#__PURE__*/_jsx(ListItem, {
          children: renderMenuItem(item, index2)
        }, index2));
        if (abstractTree.length > index + 1) {
          items.push( /*#__PURE__*/_jsx(DropdownDivider, {}, `divider-${index}`));
        }
        return items;
      }
      return /*#__PURE__*/_jsx(ListItem, {
        children: renderMenuItem(option, index)
      }, index);
    })
  });
};